import { render, staticRenderFns } from "./BuildInfo.vue?vue&type=template&id=dd37337c&scoped=true&"
import script from "./BuildInfo.vue?vue&type=script&lang=js&"
export * from "./BuildInfo.vue?vue&type=script&lang=js&"
import style0 from "./BuildInfo.vue?vue&type=style&index=0&id=dd37337c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd37337c",
  null
  
)

export default component.exports